import { render, staticRenderFns } from "./expired-products.vue?vue&type=template&id=96046496&"
import script from "./expired-products.vue?vue&type=script&lang=js&"
export * from "./expired-products.vue?vue&type=script&lang=js&"
import style0 from "./expired-products.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports